import React, { Component, Fragment } from "react";
import { Grid } from "@mui/material";
import "./test.scss";
import Webcam from "react-webcam";
import {
  withRouter
} from "react-router-dom/cjs/react-router-dom.min";
import TestView from "./testView";
import { connect, } from "react-redux";
import {
  openQuiz,
  getQuestions,
  closeQuiz1, selectAnswer, getScore, uploadImage
} from "../../ActionCreators/proctoredTestAction";
import { bindActionCreators } from "redux";
import ToastNotification from "../../utils/toast";



var timer = 0;
const goFullScreen = () => {
  const element = document.body;
  if (element.requestFullScreen) {
    element.requestFullScreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen();
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen();
  }
};



class CaptureView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      test: true,
      quiz: false,
      count: 0,
      seconds: 0,
      time: {},
      imgSrc: [],
      msg: "",
      img: false,
      imgSrcFile: [],
      violations: '',
      images: [],
      show: false,
      blurScreen: false,
      eCount: 0,
      error: false, click: false
    };
  }

  webcamRef = React.createRef();

  componentDidMount = () => {

    goFullScreen();
    console.log(this.props.unlock)
    if (this.props.unlock) {
      this.openTest();
    } else {
      this.setState({
        test: false
      })
    }
    this.setState({
      violations: this.props.violations,
    });
    window.addEventListener('blur', (event) => {
      // event.preventDefault();
      this.setState({
        blurScreen: true,
        eCount: this.state.eCount + 1
      })
      return false;
    });
  };

  componentWillUnmount = () => {
    window.removeEventListener('blur', (event) => {
      // event.preventDefault();
      this.setState({
        blurScreen: false,
        eCount: 0
      })
      return false;
    });

  }

  handleEnd = () => {
    this.setState({
      show: false
    })
  }

  alertUser = e => {
    e.preventDefault()
    e.returnValue = ''

    this.setState({
      show: true
    })
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.violations !== this.state.violations) {
      this.setState({
        violations: this.props.violations,
      },
        () => {
          this.setState({
            show: true
          })
          // return this.props.setViolations("");
        }
      );
    } else {
      goFullScreen();
    }

  };



  openTest = () => {
    this.setState({
      test: true,
    }, () => {

      let obj = {
        skill_id: this.props.testId
      }
      this.props.openQuiz(obj);
    }
    );
  };

  startTimer = () => {
    if (timer === 0 && this.state.seconds > 0) {
      timer = setInterval(this.countDown, 1000);
    }
  };

  secondsToTime(secs) {
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    let obj = {
      h: hours,
      m: (minutes < 10 ? "0" : "") + minutes,
      s: (seconds < 10 ? "0" : "") + seconds,
    };
    return obj;
  }

  countDown = () => {
    let seconds = this.state.seconds - 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });

    // Check if we're at zero.
    if (seconds === 0) {
      clearInterval(timer);
      this.quizSubmited(this.props.quizDetails?.test_id);
    }
  };

  goToQuestion = async (ques) => {
    window.scrollTo(0, 0);
    timer = 0;
    this.setState(
      {
        quiz: true,
        quizCompleted: false,
        seconds:
          this.props.quizDetails?.time !== undefined &&
          Math.round(this.props.quizDetails?.time),
      },
      () => {
        this.startTimer();
        this.props.getQuestions(ques);
      }
    );
  };

  getNext = (count) => {
    this.setState({ count: this.state.count + 1 }, () => {
      this.props.getQuestions(this.props.questions[this.state.count]);
    });
  };

  getPrev = (count) => {
    this.setState({ count: this.state.count - 1 }, () => {
      this.props.getQuestions(this.props.questions[this.state.count]);
    });
  };

  quizSubmited = async (id, images, error_count) => {
    const answered = this.props.questions.filter(el => el.answered !== null).map(e => [{ q_id: e._id, a_id: e.answered }][0]);
    let obj = {
      test_id: id,
      data: answered,
      images: this.state.images.concat(images),
      error_count: error_count,
      anti_cheat: error_count >= 3 ? true : false
    }
    !this.state.quizCompleted && await this.props.getScore(obj)
    await this.setState({
      quizCompleted: true,
      quiz: false,
    });
    clearInterval(timer);
  };

  closeQuizpopup = () => {
    this.props.closeQuiz1();
    this.setState({
      quiz: false,
      quizCompleted: false,
      count: 0,
      correctQuestion: [],
    });
    // closeFullscreen();
    window.location.href = '/tests'
  };


  capture = async () => {
    console.log('ddd')
    this.setState({
      click: true
    })
    const imageSrc = this.webcamRef.current.getScreenshot();
    console.log(imageSrc)
    const file = await this.dataURLtoFile(imageSrc, "pp");
    if (file) {
      await this.props.uploadImage(file);
      this.setState({
        images: [...this.state.images, this.props.image],
        imgSrc: [...this.state.imgSrc, imageSrc],
        img: true,
        click: false
      });
    }
    else {
      this.setState({
        img: false
      })
    }
  };

  dataURLtoFile = (dataurl, filename) => {
    if (dataurl) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: 'image/png' });
    } else {
      this.setState({
        error: true
      })
    }
  };

  setClose = () => {
    this.setState({
      show: false,
      blurScreen: false,
      error: false
    })
  }

  handleError = (err) => {
    console.log(err.message)
  }


  render() {
    const { count, img, imgSrc, quiz, test } = this.state;
    const { isQuiz, quizDetails, question, questions, details } = this.props;
    goFullScreen();

    return (
      <div className="backgroundView">
        {<ToastNotification
          message={this.props.violations}
          show={this.state.show}
          setClose={this.setClose}
        />}
        {<ToastNotification
          message={'Browser Switching not allowed'}
          show={this.state.blurScreen}
          setClose={this.setClose}
        />}
        {<ToastNotification
          message={'Please check your browser setting and turn on your webcam '}
          show={this.state.error}
          setClose={this.setClose}
        />}

        {!test ?
          <div className="webcam-specs">
            <h1>Instructions:-</h1>
            <h2>1. A web camera is needed to click proctoring webcam shots.</h2>

            <h2>2. Your webcam feed will be shown below (if the webcam is available). If requested, please allow your browser to access/share your camera feed.</h2>

            <h2>3. If the screen shows your feed, Click on 'Capture Photo' and then 'Go to test'. If there is no video feed, it is possible that your webcam is either inactive or not installed properly. Please reconnect your camera again, and refresh this page.</h2>

            <h2>4. Supported Operating systems are: Windows and MAC </h2>
          </div> :
          null
        }
        {
          !test ?
            (
              <Grid
                container
                className="center"
                direction="row"
                spacing={2}
                alignItems="center"
                style={{ padding: "2%", background: "#fff" }}
              >
                <Grid item xs={window.innerWidth > 767 ? 6 : 12} >
                  <div
                    style={{
                      width: "100%",
                      height: "44vh",
                      // background: "rgb(240,240,250)",
                    }}
                  >
                    {img ? (
                      <div >
                        {window.innerWidth > 767 ?
                          <img src={imgSrc.map((el) => el)} alt="" style={{ width: '100%', height: '44vh', }} /> :
                          <img src={imgSrc.map((el) => el)} alt="" style={{ width: '100%', height: '41vh', }} />
                        }
                      </div>
                    ) : (
                      <Fragment>
                        {/* {window.innerWidth > 767 ? */}
                        <Webcam
                          style={{ display: !test ? 'block' : 'none', width: "100%", height: window.innerWidth > 767 ? '44vh' : '39vh' }}
                          audio={false}
                          ref={this.webcamRef}
                          // screenshotFormat="image/jpeg"
                          videoConstraints={{ facingMode: "user" }}
                          mirrored={true}
                          imageSmoothing={true}
                          screenshotQuality={1}
                          onUserMediaError={(err) => this.handleError(err)}
                        />
                        {/* (
                            <Camera
                              style={{ display: !test ? 'block' : 'none', width: "100%", height: window.innerWidth > 767 ? '44vh' : '39vh' }}
                              isImageMirror={true}
                              isDisplayStartCameraError={true}
                              onCameraError={(error) => { this.handleCameraError(error); }}
                              onTakePhoto={(dataUri) => { this.handleTakePhoto(dataUri); }}
                            />) */}

                        <button
                          className="text-center mt-4"
                          disabled={this.state.click ? true : false}
                          style={{ background: "#8b7df2", color: '#fff', width: 160, height: 40, position: window.innerWidth > 767 ? 'static' : 'relative', zIndex: window.innerWidth > 767 ? '' : 4, marginBottom: 80, border: 'none' }}
                          onClick={this.capture}
                        >
                          Capture photo
                        </button>
                      </Fragment>
                    )}
                  </div>
                </Grid>
                <Grid item xs>
                  <Grid xs>
                    <div
                      className="details"
                      style={{
                        height: window.innerWidth > 767 ? "34vh" : '55vh',
                        textAlign: 'left',
                        marginTop: window.innerWidth > 767 ? '' : 80
                      }}
                    >
                      <h1>Test Details</h1>
                      <h2>1. Proctored online test</h2>
                      <h2>2. {details?.questions} multiple-choice questions</h2>
                      <h2>3. {Math.round(details?.time / 60)} minutes</h2>
                      <h2>4. Each question has between 2 and 8 options out of which 1 will be correct.</h2>
                      {window.innerWidth < 767 &&
                        <div className="d-flex justify-content-center">
                          <button
                            disabled={img ? false : true}
                            style={{ background: "#8b7df2", marginTop: 20, color: '#fff', opacity: img ? 1 : 0.5, width: 160, height: 40, border: 'none' }}
                            onClick={() => {
                              this.openTest();
                            }}
                          >
                            Go to Test
                          </button>
                        </div>
                      }
                    </div>
                  </Grid>

                  {window.innerWidth > 767 &&
                    <Grid item xs>
                      <div
                        className="stopButton"
                        style={{
                          height: "9.5vh",
                          padding: "4vh",
                        }}
                      >
                        <div>

                          <Grid item xs>
                            <button
                              disabled={img ? false : true}
                              style={{ background: "#8b7df2", color: '#fff', opacity: img ? 1 : 0.5, width: 160, height: 40, border: 'none' }}
                              onClick={() => {
                                this.openTest();
                              }}
                            >
                              Go to Test
                            </button>
                          </Grid>
                        </div>
                      </div>
                    </Grid>}
                </Grid>
              </Grid>
            ) : (
              <div
                className="feed-details mob-style"
                style={{
                  zIndex: window.location.pathname === "/start-test" ? 8 : 7,
                  display: isQuiz ? "block" : "none",
                }}
              >
                <TestView
                  // type={this.state.type}
                  learn={this.props.learn}
                  activeFeedData={quizDetails}
                  title={this.props.title}
                  questions={questions}
                  question={question}
                  quiz={quiz}
                  goToQuestion={this.goToQuestion}
                  quizSubmited={this.quizSubmited}
                  count={count}
                  getNext={this.getNext}
                  getPrev={this.getPrev}
                  score={this.props.score}
                  quizCompleted={this.state.quizCompleted}
                  time={this.state.time}
                  selectAnswer={this.props.selectAnswer}
                  closeQuizpopup={this.closeQuizpopup}
                  unlock={this.props.unlock}
                  capture={this.capture}
                  uploadImage={this.props.uploadImage}
                  image={this.props.image}
                  errorCount={this.props.count}
                  eCount={this.state.eCount}
                />
              </div>
            )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { isQuiz, quizDetails, question, questions, score, image } = state.proctored;
  return {
    isQuiz,
    quizDetails,
    question,
    questions,
    score, image
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ openQuiz, getQuestions, closeQuiz1, selectAnswer, getScore, uploadImage }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CaptureView));